var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNineDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 40,
    height: 40,
    style: {
      cursor: "pointer"
    },
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "20;60;100;20",
    dur: "2s",
    begin: "svg.click+0s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 20,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "60;100;20;60",
    dur: "2s",
    begin: "svg.click+0.2s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 20,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "100;20;60;100",
    dur: "2s",
    begin: "svg.click+0.4s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 60,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "20;60;100;20",
    dur: "2s",
    begin: "svg.click+0.6s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "60;100;20;60",
    dur: "2s",
    begin: "svg.click+0.8s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 60,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "100;20;60;100",
    dur: "2s",
    begin: "svg.click+1s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 100,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "20;60;100;20",
    dur: "2s",
    begin: "svg.click+1.2s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 100,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "60;100;20;60",
    dur: "2s",
    begin: "svg.click+1.4s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 10,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "100;20;60;100",
    dur: "2s",
    begin: "svg.click+1.6s"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNineDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nine-dots.8c890e9007e5f17219410d14dc06c373.svg";